if (!customElements.get('promo-collection-cards')) {
    class PromoCollectionCards extends HTMLElement {
      connectedCallback() {
        this._grid = this.querySelector('.mugo-promo-cards__grid');
        this._dotsWrap = this.querySelector('.mugo-promo-cards__dots');
        if (!this._grid || !this._dotsWrap) return;
  
        this._dots = Array.from(this._dotsWrap.querySelectorAll('.mugo-promo-cards__dot'));
  
        this._onScroll = this._updateDots.bind(this);
        this._onResize = this._updateDots.bind(this);
  
        this._grid.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onResize);
  
        this._dots.forEach((dot) => {
          dot.addEventListener('click', () => this._scrollToCard(parseInt(dot.dataset.index, 10)));
        });
      }
  
      disconnectedCallback() {
        if (this._grid) this._grid.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onResize);
      }
  
      _isMobile() {
        return window.innerWidth <= 767;
      }
  
      _updateDots() {
        if (!this._isMobile() || this._dots.length === 0) return;
        const cards = Array.from(this._grid.querySelectorAll('.mugo-promo-cards__card'));
        const centerX = this._grid.scrollLeft + this._grid.offsetWidth / 2;
        let closest = 0;
        let minDist = Infinity;
        cards.forEach((card, i) => {
          const dist = Math.abs((card.offsetLeft + card.offsetWidth / 2) - centerX);
          if (dist < minDist) { minDist = dist; closest = i; }
        });
        this._dots.forEach((d, i) => d.classList.toggle('is-active', i === closest));
      }
  
      _scrollToCard(idx) {
        const cards = Array.from(this._grid.querySelectorAll('.mugo-promo-cards__card'));
        if (!cards[idx]) return;
        const card = cards[idx];
        this._grid.scrollTo({
          left: card.offsetLeft - (this._grid.offsetWidth - card.offsetWidth) / 2,
          behavior: 'smooth'
        });
      }
    }
  
    customElements.define('promo-collection-cards', PromoCollectionCards);
  }